import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { GetResearchCategoryList } from "../../api/research-category-functions";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import globalVariables from "../../global-variables";
import Metatag from "../../hooks/Metatag";


export default function Research() {

  const navigate = useNavigate();
  const [getrcategoryList, setRcategoryList] = useState(null);


  const OnGetResearchCategorySuccess = (p_response) => {

    // set the list for looping
    setRcategoryList(p_response);
  }
  // things to be done when the page is loaded
  useEffect(() => {

    // make the object for getting the research category list
    let _obj = new Object();
    _obj.rcategory_status = 1;

    // call the function to get the research category
    GetResearchCategoryList(_obj, OnGetResearchCategorySuccess, navigate);

  }, []);

  useEffect(() => {

    // remove bg-header-home 
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10 ? $(".fixed-top").removeClass("bg-header-home") : $(".fixed-top").removeClass("bg-header-home")
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [])

  return (
    <>
      <Header></Header>
      {/* MetaTag */}

      <Metatag title='Sustainability Research Projects by IIT Bombay'
        description='Sustainability Research Projects by IIT Bombay'
        keywords="Sustainability Research Projects by IIT Bombay"
      />


      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
        <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Overview
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>


      <Container className="my-5 pt-md-5">
        <div className="border p-md-5 p-4 rounded-4">
          <Row>
            <Col className="col-md-8 pe-md-5">
              <p className="wow fadeInUp">The IIT Bombay Research Hub for Green Energy and Sustainability (GESH IITB) serves as a premier platform for advancing interdisciplinary research and innovation in green energy, climate studies, and sustainability. The objective is to carry out blue-sky, translational, and educational research and development programs in green energy and sustainability, including climate services and solutions and related areas. The research vertical addresses critical challenges through cutting-edge scientific exploration and collaboration between academia, industry, and policymakers.</p>
              <h6 className="mt-4 wow fadeInUp">Key Objectives include:</h6>
              <Row className="row-cols-xl-4 row-cols-2 gx-md-4 gy-md-0 g-3 mt-3 text-center">
                <Col className="align-items-center overflow-hidden">
                  <div className="mb-2">
                    <div className="icon-100 bg-primary rounded-circle p-1 overflow-hidden mx-auto">
                      <img src={(global.variables.strDomainUrl + "images/icon-innovative-solutions.png")} className="img-fluid p-3 wow fadeInUp" loading="lazy" alt="Innovative Solutions" title="Innovative Solutions" width={100} height={100} />
                    </div>
                  </div>
                  <div>
                    <p className="m-0 wow fadeInUp">Innovative Solutions</p>
                  </div>
                </Col>
                <Col className="align-items-center overflow-hidden">
                  <div className="mb-2">
                    <div className="icon-100 bg-primary rounded-circle p-1 overflow-hidden mx-auto">
                      <img src={(global.variables.strDomainUrl + "images/icon-translational-research.png")} className="img-fluid p-3 wow fadeInUp" loading="lazy" alt="Translational Research" title="Translational Research" width={100} height={100} />
                    </div>
                  </div>
                  <div>
                    <p className="m-0 wow fadeInUp">Translational Research</p>
                  </div>
                </Col>
                <Col className="align-items-center overflow-hidden">
                  <div className="mb-2">
                    <div className="icon-100 bg-primary rounded-circle p-1 overflow-hidden mx-auto">
                      <img src={(global.variables.strDomainUrl + "images/icon-collaborative-approach.png")} className="img-fluid p-3 wow fadeInUp" loading="lazy" alt="Collaborative Approach" title="Collaborative Approach" width={100} height={100} />
                    </div>
                  </div>
                  <div>
                    <p className="m-0 wow fadeInUp">Collaborative Approach</p>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={4} lg={4} className="d-md-block d-none">
              <img src={global.variables.strDomainUrl + "images/pic-research.png"} className="img-fluid rounded-3 w-100 wow fadeInUp" />
            </Col>
          </Row>
        </div>
      </Container>
      <Container className="mb-5">

        <h4 className="mb-4 text-center wow fadeInUp">GESH IITB Projects</h4>
        <Row>
          <Col className="mb-4 col-md-6 pe-md-5 list">
            <div className="bg-light-green p-md-5 p-4 rounded-4 h-100">
              <h6 className="wow fadeInUp">The research in GESH IITB is subdivided into the following:</h6>
              <ul>
                <li className="wow fadeInUp">Faculty Initiated</li>
                <li className="wow fadeInUp">Hub Initiated</li>
                <li className="wow fadeInUp">Industry-Academia Collaboration</li>
                <li className="wow fadeInUp">Student Initiated</li>
                <li className="wow fadeInUp">Hub facilitated</li>
              </ul>

              <h6 className="wow fadeInUp">The broad categories are:</h6>
              <ul className="m-0">
                <li className="wow fadeInUp">Green Energy Technologies</li>
                <li className="wow fadeInUp">Environment and Infrastructure</li>
                <li className="wow fadeInUp">Climate Services and Solutions</li>
                <li className="wow fadeInUp">Campus Sustainability</li>
                <li className="wow fadeInUp">Sustainable Manufacturing</li>
                <li className="wow fadeInUp">Education</li>
              </ul>
            </div>
          </Col>
          <Col className="mb-4 col-md-6 list">
            <div className="bg-green p-md-5 p-4 rounded-4 h-100">
              <h6 className="wow fadeInUp">The research projects are classified into following Focus Areas:</h6>
              <ul className="m-0">
                <li className="wow fadeInUp">Sustainable Transportation</li>
                <li className="wow fadeInUp">Sustainable Infrastructure</li>
                <li className="wow fadeInUp">Environmental studies and monitoring</li>
                <li className="wow fadeInUp">Climate science and solutions</li>
                <li className="wow fadeInUp">Food-Water-Energy Nexus</li>
                <li className="wow fadeInUp">Batteries and Fuel Cells</li>
                <li className="wow fadeInUp">Solar Thermal and Photovoltaics</li>
                <li className="wow fadeInUp">Circular Economy</li>
                <li className="wow fadeInUp">Alternative Fuels</li>
                <li className="wow fadeInUp">Green Hydrogen</li>
                <li className="wow fadeInUp">Materials</li>
                <li className="wow fadeInUp">Decarbonization</li>
                <li className="wow fadeInUp">Education</li>
              </ul>
            </div>
          </Col>
        </Row>

      </Container>



      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Research</Breadcrumb.Item>
        <Breadcrumb.Item active>Overview</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}